import { render, staticRenderFns } from "./onebox-managefunction.vue?vue&type=template&id=a9a59db2&"
import script from "./onebox-managefunction.vue?vue&type=script&lang=js&"
export * from "./onebox-managefunction.vue?vue&type=script&lang=js&"
import style0 from "./onebox-managefunction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports